import { render, staticRenderFns } from "./CopyLinkButton.vue?vue&type=template&id=61753e2b"
import script from "./CopyLinkButton.vue?vue&type=script&lang=ts"
export * from "./CopyLinkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports